import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";

function CadastroCliente() {
    // Captura os parâmetros passados na rota: /evento/:evento/:dataevento
    const { evento, dataevento } = useParams();

    const [cpf, setCpf] = useState("");
    const [nome, setNome] = useState("");
    const [telefone, setTelefone] = useState("");
    const [email, setEmail] = useState("");
    const [seqPessoa, setSeqPessoa] = useState(null);
    const [nomeBloqueado, setNomeBloqueado] = useState(false);

    const somenteNumeros = (str = "") => String(str).replace(/\D/g, "");

    // Trata e limpa o nome do evento vindo da URL (substitui '_' e '-' por espaço)
    const obterEventoTratado = (nomeEvento) => {
        if (!nomeEvento) return "";
        return nomeEvento.replace(/_|-/g, " ").trim();
    };

    // Formata para exibição nas mensagens (ex: "Alegria com os Idosos")
    const formatarNomeEvento = (nomeEvento) => {
        const eventoTratado = obterEventoTratado(nomeEvento);
        if (!eventoTratado) return "Evento";
        return eventoTratado;
    };

    // Validação oficial de CPF
    const validarCPF = (cpfRaw) => {
        const cpf = somenteNumeros(cpfRaw);
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

        let soma = 0;
        for (let i = 0; i < 9; i++) soma += parseInt(cpf[i], 10) * (10 - i);
        let resto = (soma * 10) % 11;
        if (resto === 10) resto = 0;
        if (resto !== parseInt(cpf[9], 10)) return false;

        soma = 0;
        for (let i = 0; i < 10; i++) soma += parseInt(cpf[i], 10) * (11 - i);
        resto = (soma * 10) % 11;
        if (resto === 10) resto = 0;
        return resto === parseInt(cpf[10], 10);
    };

    const getLinkCadastro = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "https://play.google.com/store/apps/details?id=br.com.gsgroup.zoombox.supermarket";
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "https://apps.apple.com/br/app/superclube-supermarket/id1581860985";
        } else {
            return "https://cadastrosuperclube.redesupermarket.com.br/";
        }
    };

    // Buscar cliente pelo CPF
    const buscarCliente = async () => {
        const cpfLimpo = somenteNumeros(cpf);
        if (!validarCPF(cpfLimpo)) {
            Swal.fire("Erro", "CPF inválido", "error");
            return;
        }

        try {
            const { data } = await api.get("/cliente/cpf", { params: { cpf: cpfLimpo } });

            if (Array.isArray(data) && data.length > 0) {
                const cliente = data[0];
                const seq = cliente.seqpessoa ?? 0;

                if (seq && seq !== 0) {
                    setSeqPessoa(seq);
                    setNome(cliente.nomerazao || "");
                    setTelefone(cliente.cli_telefone || "");
                    setEmail(cliente.cli_email || "");
                    setNomeBloqueado(true);

                    if (!cliente.cli_telefone || cliente.cli_telefone.trim() === "") {
                        Swal.fire(
                            "Complete seu cadastro",
                            `Para participar do evento ${formatarNomeEvento(evento)}, cadastre seu telefone e e-mail.`,
                            "info"
                        );
                    }
                } else {
                    setSeqPessoa(null);
                    setNome(cliente.nomerazao || "");
                    setTelefone(cliente.cli_telefone || "");
                    setEmail(cliente.cli_email || "");
                    setNomeBloqueado(true);
                    Swal.fire(
                        "Por detalhes",
                        "Você ainda não baixou o APP Superclube para garantir as melhores ofertas!",
                        "info"
                    );
                }
            } else {
                setSeqPessoa(null);
                setNome("");
                setTelefone("");
                setEmail("");
                setNomeBloqueado(false);
                Swal.fire(
                    "Seja bem-vindo!",
                    `Preencha seus dados para se cadastrar no evento ${formatarNomeEvento(evento)}.`,
                    "info"
                );
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Erro", "Falha ao buscar cliente", "error");
        }
    };

    // Gravar dados
    const gravarCliente = async () => {
        const cpfLimpo = somenteNumeros(cpf);

        if (!validarCPF(cpfLimpo)) {
            Swal.fire("Erro", "CPF inválido", "error");
            return;
        }

        if (!nome || !telefone) {
            Swal.fire("Erro", "Preencha CPF, Nome e Telefone", "error");
            return;
        }

        try {
            // Remove o '_' e envia como texto limpo com espaços para a API salvar no banco
            const eventoFormatadoBanco = obterEventoTratado(evento);

            const body = {
                cpf: cpfLimpo,
                nome: nome.toUpperCase(),
                telefone,
                ...(email ? { email } : {}),
                ...(seqPessoa ? { seqpessoa: seqPessoa } : {}),
                ...(eventoFormatadoBanco ? { evento: eventoFormatadoBanco } : {}),
                ...(dataevento ? { dataevento } : {})
            };

            const response = await api.post("/cliente/cpf", body);
            const status = response.status;

            if (status === 200 || status === 201) {
                const nomeEventoExibicao = formatarNomeEvento(evento);

                if (!seqPessoa) {
                    await Swal.fire({
                        title: `Bem-vindo ao ${nomeEventoExibicao}!`,
                        html: `Você ainda não é cliente <strong>Superclube</strong>.<br>
                   Para garantir <strong>descontos exclusivos</strong> e ofertas especiais, baixe o nosso APP e conclua seu cadastro.`,
                        icon: "info",
                        confirmButtonText: "Abrir link de download"
                    });
                    window.open(getLinkCadastro(), "_blank");
                } else {
                    await Swal.fire({
                        title: `Bem-vindo ao ${nomeEventoExibicao}!`,
                        text: "Seu cadastro para o evento foi confirmado com sucesso.",
                        icon: "success",
                        confirmButtonText: "Ir para o site"
                    });
                    window.location.href = "https://www.redesupermarket.com.br/";
                }
            } else {
                Swal.fire("Erro", "Falha ao salvar dados", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Erro", "Falha na comunicação com o servidor", "error");
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                <div className="container p-4 shadow-sm bg-light rounded" style={{ maxWidth: 500 }}>
                    <div className="text-center mb-4">
                        <img
                            src="https://www.florestasm.com.br/Images/Floresta.png"
                            alt="Floresta Supermarket"
                            title="Floresta Supermarket"
                            style={{ 
                                maxHeight: "50px", 
                                maxWidth: "100%", 
                                height: "auto", 
                                display: "block", 
                                margin: "0 auto" 
                            }}
                        />
                    </div>

                    <label>CPF:</label>
                    <InputMask
                        mask="999.999.999-99"
                        className="form-control"
                        value={cpf}
                        onChange={(e) => setCpf(e.target.value)}
                    />
                    <button className="btn btn-primary mt-3 w-100" onClick={buscarCliente}>
                        Buscar
                    </button>

                    <label className="mt-3">Nome:</label>
                    <input
                        type="text"
                        className="form-control"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        disabled={nomeBloqueado}
                    />

                    <label className="mt-3">Telefone (WhatsApp):</label>
                    <InputMask
                        mask="(99) 99999-9999"
                        className="form-control"
                        value={telefone}
                        onChange={(e) => setTelefone(e.target.value)}
                    />

                    <label className="mt-3">E-mail (opcional):</label>
                    <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <button className="btn btn-success mt-4 w-100" onClick={gravarCliente}>
                        Continuar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CadastroCliente;